import { PAGE_SLUG, type PageMeta } from '@web-studio/shared-schemas';
import { pickLocalized } from './localized';
import { pickChrome } from './siteChromeCopy';

/** H1 on Imprint / Policy — prefer translated page title, else platform chrome. */
export function resolveLegalPageHeading(
  kind: 'impressum' | 'datenschutz',
  locale: string,
  pages?: PageMeta[] | null,
): string {
  const slug = kind === 'impressum' ? PAGE_SLUG.impressum : PAGE_SLUG.datenschutz;
  const fromPage = pages
    ? pickLocalized(pages.find((page) => page.slug === slug)?.localizedTitle, locale).trim()
    : '';
  if (fromPage) {
    return fromPage;
  }
  return pickChrome(kind === 'impressum' ? 'imprintTitle' : 'privacyTitle', locale);
}
